/** «Источники» лидов — ровно то, что отдаёт `GET /api/leads/sources`. */
import { apiFetch, query } from "@/lib/api";

/** Воронка лидов строки — как в «По дням» (`LeadDayCounts`). */
export type SourceCounts = {
  leads: number;
  valid_phone: number;
  in_work: number;
  phones: number;
  new: number;
  deal: number;
  recorded: number;
  booked: number;
};

/** Заявки сайта по дате заявки: попап, баннер, заказ. */
export type WebCounts = {
  submissions: number;
  /** Спам / нет контактов (попап), тестовый номер (баннер). */
  dropped: number;
  to_lead: number;
  /** Лид создан раньше заявки больше чем на 10 мин — заявку дописали в старый. */
  to_old_lead: number;
};

export type SourceRow = SourceCounts & { key: string; label: string; web: WebCounts | null };
export type SourceGroup = SourceRow & { children: SourceRow[] };

export type LeadSources = {
  from: string;
  to: string;
  total: SourceCounts & { web: WebCounts | null };
  groups: SourceGroup[];
  adverts: SourceRow[];
};

export function loadLeadSources(from: string, to: string): Promise<LeadSources> {
  return apiFetch<LeadSources>(`/api/leads/sources${query({ from, to })}`);
}

/** «По дням» — `GET /api/leads/sources/days`: только уникальные рабочие номера. */
export type PhoneCounts = { phones: number; new: number; deal: number; recorded: number; booked: number };
export type ChannelCells = { all: PhoneCounts; by: Record<string, PhoneCounts> };
export type ChannelRow = ChannelCells & { day: string; to: string };
export type ChannelPeriod = {
  from: string;
  to: string;
  total: ChannelCells & { excluded: PhoneCounts };
  days: ChannelRow[];
  weeks: ChannelRow[];
  months: ChannelRow[];
};
export type LeadSourcesDays = { channels: { key: string; label: string }[]; periods: ChannelPeriod[] };

export function loadLeadSourcesDays(from: string, to: string, cfrom?: string, cto?: string): Promise<LeadSourcesDays> {
  const q = cfrom && cto ? { from, to, cfrom, cto } : { from, to };
  return apiFetch<LeadSourcesDays>(`/api/leads/sources/days${query(q)}`);
}
